export default __webpack_public_path__ + "static/media/aiObjectInActive.2f282a96.svg";